<template>
  <div class="acknowledgement-preview-skeleton d-flex flex-column ga-4">
    <section class="acknowledgement-preview-skel-header d-flex flex-column align-center ga-2">
      <v-skeleton-loader
        type="text"
        width="65%"
        class="acknowledgement-preview-skel-line"
      />
      <v-skeleton-loader
        type="text"
        width="40%"
        class="acknowledgement-preview-skel-line"
      />
      <v-skeleton-loader
        type="text"
        width="55%"
        class="acknowledgement-preview-skel-line"
      />
    </section>

    <section
      v-for="i in fieldCount"
      :key="i"
      class="acknowledgement-preview-skel-field"
    >
      <v-divider
        v-if="i > 1"
        class="opacity-100 mt-3 mb-4"
      />
      <v-skeleton-loader
        type="text"
        width="35%"
        class="mb-2 acknowledgement-preview-skel-line"
      />
      <v-skeleton-loader
        type="text"
        width="100%"
        class="mb-1 acknowledgement-preview-skel-line"
      />
      <v-skeleton-loader
        type="text"
        :width="fieldBodyWidth(i)"
        class="acknowledgement-preview-skel-line"
      />
    </section>
  </div>
</template>

<script setup>
const fieldCount = 2;

const fieldBodyWidth = (index) => {
  const widths = ['92%', '78%'];

  return widths[index - 1] ?? '85%';
};
</script>

<style scoped lang="less">
:deep(.v-skeleton-loader .v-skeleton-loader__text) {
  background: @bg-canvas;
}

.acknowledgement-preview-skel-line :deep(.v-skeleton-loader__text) {
  height: 16px;
  border-radius: 6px;
}
</style>
